import { isNotEmpty } from '@doltech/utils/lib/text';
import { Instance, types as t } from 'mobx-state-tree';

import { AdminCorrectOption } from '../admin-correct-option.store';

export const AdminCorrectAnswer = AdminCorrectOption.named('AdminCorrectAnswer')
  .props({
    value: t.maybeNull<any>(t.string),
  })
  .actions((self) => ({
    setCorrectValue(value: string) {
      if (!isNotEmpty(value)) {
        self.value = null;
      } else {
        self.value = value;
      }
    },
    setKey(key: number) {
      self.key = key;
    },
  }))
  .views((self) => {
    const { isCompletedFn, isDirtyFn } = self;
    return {
      get isCompleted() {
        return isNotEmpty(self.value) && isCompletedFn();
      },
      get isDirty() {
        return isNotEmpty(self.value) || isDirtyFn();
      },
    };
  });

export interface AdminCorrectAnswerInstance extends Instance<typeof AdminCorrectAnswer> {}
